export default __webpack_public_path__ + "static/media/logo.1f0d4429.png";